module.exports = __webpack_public_path__ + "img/LOGO.e04da119.svg";